// extracted by mini-css-extract-plugin
module.exports = {"grade-total":"Receives_grade-total__2ZoJi","label-text":"Receives_label-text__3vBqG","compressionReceives":"Receives_compressionReceives__3S5pI"};